module.exports = __webpack_public_path__ + "static/home-8b89e2c04c419b7bd55fea867d9ef5b3.jpg";